import {merge} from '#core/utils/config-utils.js';
import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePopover} from '#core/application/modules/tiles/popover/index.js';
import {generateSwitch} from '#core/application/modules/tiles/switch/index.js';

export function betslipSettingsFactory(PALETTE) {
    return {
        BetslipSettings: {
            highlightedSettingsIndicator: {
                style: {
                    ...resolveBackground(PALETTE.BETSLIP_SETTINGS_BUTTON_DOT_NOTIFICATION.DOT_COLOR),
                    borderWidth: 0,
                },
            },
            popupToggleButtonIcon: icon(PALETTE.BETSLIP_SETTINGS_BUTTON.TERTIARY_BUTTON_ICON_COLOR),
            popup: merge(generatePopover(PALETTE.BETSLIP_SETTINGS_POPOVER), {
                arrowheadOffset: '9px',
                container: {
                    style: {
                        left: '4.5px',
                        bottom: 38,
                    },
                },
                content: {
                    style: {
                        base: {
                            borderStyle: 'none',
                            _mobile_width: 'calc(100vw - 11%)',
                        },
                    },
                },
            }),
        },
        BettingSettings: {
            toggleButton: generateSwitch(PALETTE.BETSLIP_SETTINGS_SWITCH),
        },
    };
}
